<template>
  <a-modal v-bind:open="this.showModal"
           width="800px"
           :closable="true"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
           @cancel="uiHandler.closeModal"
  >
    <div class="modal-content-body">
      <div class="search-client-header">
        <div class="modal-title">
          병원 렌탈 목록
        </div>
        <button
            type="button"
            class="btn-close"
            @click="uiHandler.closeModal"
        >
          <i class="fa-regular fa-x"/>
        </button>
      </div>
      <div class="search-client-content d-flex justify-content-center flex-column align-items-center">
        <div class="list-container">
          <div class="list-items" v-if="processedDataSource.length > 0">
            <div
                v-for="(item, index) in processedDataSource"
                class="list-item"
                :class="item.isSelected ? 'selected' : ''"
                @click="uiHandler.chooseItem(index)"
            >
              <a-typography-text :ellipsis="true" style="width: 100%;">
                <div class="item-left">
                  {{ item.orderName }}
                </div>
              </a-typography-text>
              <div class="item-right" v-if="item.isSelected">
                <i class="fa-solid fa-check"/>
              </div>
            </div>
          </div>
          <div
              v-else
              style="
                align-items: center;
                justify-content: center;
                display: flex;
                margin-top: 164px;"
          >
            <no-result
                :colspan="10"
                :message="computedNoResultMessage"
                :height="'auto'"
                :noIcon="true"
            />
          </div>
          <div
              v-if="$store.state.isLoading !== false || processedDataSource === 0"
              class="page-wrapper"
          />
          <pagination
              v-if="$store.state.isLoading === false && processedDataSource > 0"
              :page-info="paginationData"
              page-name="SearchClientModal"
              :pagePerBlock="5"
              @change-page="uiHandler.paginationHandler"
          />
        </div>
      </div>
    </div>
    <div class="expiration-modal-footer">
      <a-button
          @click="uiHandler.closeModal"
      >
        취소
      </a-button>
      <a-button
          type="primary"
          @click="uiHandler.emitHospitalRental"
      >
        선택한 렌탈내역 적용하기
      </a-button>
    </div>
  </a-modal>
</template>
<script>
import {oneBtnDialog} from "@/utils/utils";
import contractApi from "@/views/ContractManagement/api";
import NoResult from "@/views/components/NoResult.vue";
import Pagination from "@/views/components/Pagination.vue";
import {EmitEvents} from "@/views/ContractManagement/contracts/dentium/EmitEvents";

const readOnly = {
  event: {
    CloseModal: "CloseModal"
  },
}

export default {
  components: {Pagination, NoResult},
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    dataSource: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  emits: Object.keys({...EmitEvents.ClientModal, ...EmitEvents.Common}),
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.processedDataSource = this.dataSource.map((d, idx) => {
          return {...d, no: idx + 1}
        })
      }
    }
  },
  computed: {
    computedNoResultMessage() {
      return this.$i18n.t('noresult_search');
    },
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
      selectedItem: {},
      processedDataSource: [],
      payments: {
        columns: [
          {key: 'orderName', title: '주문', dataIndex: 'orderName', align: 'center'},
        ]
      }
    }
  },
  methods: {
    ui() {
      return {
        chooseItem: (index) => {
          if (this.processedDataSource[index].isSelected) return;
          this.processedDataSource.forEach((item, i) => {
            if (index !== i) item.isSelected = false;
          });
          this.processedDataSource[index].isSelected = true;
          this.selectedItem = this.processedDataSource[index];

          console.log("====>", this.processedDataSource)
          console.log("====>", this.selectedItem)
        },
        emitHospitalRental: async () => {
          await this.$emit(EmitEvents.HospitalRental.CompleteSelect, this.selectedItem);
        },
        closeModal: () => {
          this.$emit(readOnly.event.CloseModal, {
            ModalStatus: false
          });
        }
      }
    },
    api() {
      return contractApi(this.$apiInstance, this.$store)
    }
  }
}
</script>
<style scoped>
@import '@/assets/scss/hospital-rental-list-modal.scss';
</style>